import { makeStyles } from '@material-ui/core/styles';
import range from 'lodash/fp/range';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import SimpleDropdown from '~/modules/common/components/SimpleDropdown';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%'
  },
  select: {
    paddingBottom: theme.spacing(0.75),
    fontSize: theme.typography.body2.fontSize,
    height: '1.2rem'
  },
  root: {
    flexGrow: 1,
    flexShrink: 1,
    display: 'inline-flex',
    maxWidth: 170,
    '& .MuiFormControl-root .MuiFilledInput-root': {
      borderTopLeftRadius: 0
    }
  }
}));

const DayOfMonthDropdown = ({
  value,
  onChange,
  hiddenLabel = false,
  classes: classesOverride,
  selectProps,
  inputLabelProps
}) => {
  const classes = useStyles({ classes: classesOverride });
  const intl = useIntl();
  const options = useMemo(
    () =>
      range(1, 32).map(day => ({
        id: day.toString(),
        displayText: intl.formatMessage({
          id: `billPlan.dayOfMonth.${day}`
        })
      })),
    [intl]
  );

  const selectedValue = useMemo(
    () => options.find(x => value && x.id === value.toString()),
    [options, value]
  );

  const dropdownClasses = useMemo(
    () => ({
      container: classes.container,
      select: classes.select
    }),
    [classes.container, classes.select]
  );

  return (
    <div className={classes.root}>
      <SimpleDropdown
        options={options}
        onChange={onChange}
        noneOption={false}
        value={selectedValue}
        classes={dropdownClasses}
        disableSort
        variant="filled"
        hiddenLabel={hiddenLabel}
        selectProps={selectProps}
        inputLabelProps={inputLabelProps}
      />
    </div>
  );
};

DayOfMonthDropdown.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  hiddenLabel: PropTypes.bool,
  classes: PropTypes.object,
  selectProps: PropTypes.object,
  inputLabelProps: PropTypes.object
};

export default DayOfMonthDropdown;
